import { DashboardService } from "../dashboardService";
import { LocalStorageService } from "src/services/localStorageService";
import { ActiveAntsPurchaseOrderColumnHeader, CreationDateSortOptions, LocalStorageKeys } from "src/enums";
import { ActiveAntsPurchaseOrdersFilters } from "src/types";

class ActiveAntsPurchaseOrderDashService extends DashboardService<
  ActiveAntsPurchaseOrderColumnHeader,
  ActiveAntsPurchaseOrdersFilters,
  CreationDateSortOptions,
  undefined
> {
  constructor(localStorageService: LocalStorageService) {
    super(localStorageService, LocalStorageKeys.ACTIVE_ANTS_PURCHASE_ORDER_DASH_SETTINGS);
  }
}

export { ActiveAntsPurchaseOrderDashService };
